<template>
  <nav-bar title="直接付货" />
  <RoleName role="库管人员" />
  <!-- <Picker
    label="收货部门"
    :columns="groupList"
    text="departmentName"
    :border='false'
  /> -->
  <Content :bottom="76" @content-scroll="handleContentScroll">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getList" />
    <div class="title">
      <span
        >共<strong>{{ list.length }}</strong
        >瓶</span
      >
      <span
        ><strong>{{ capacity }}</strong
        >升</span
      >
    </div>
    <ul class="list">
      <li class="list-item list-title van-hairline--bottom">
        <span class="list-item__gsId">瓶号</span>
        <span class="list-item__residua-gas">容量</span>
        <span>
          <van-checkbox
            v-model="checkedAll"
            shape="square"
            @click="handleCheckedAllClick"
          />
        </span>
      </li>
      <van-checkbox-group v-model="checked" ref="checkboxGroup">
        <li
          class="list-item list-child"
          v-for="item in list"
          :key="item.cylinderId"
        >
          <span class="list-item__gsId">{{ item.cylinderCode }}</span>
          <span class="list-item__residua-gas">{{
            item.cylinderCapacity
          }}</span>
          <span>
            <van-checkbox :name="item.cylinderId" shape="square" />
          </span>
        </li>
      </van-checkbox-group>
    </ul>
    <loading-more
      :finished="finished"
      :showLoadingMore="showLoadingMore"
      :loadingFail="loadingFail"
      :list="list"
      @reload="getList"
    />
  </Content>
  <div class="btn-conatiner">
    <van-button
      block
      :loading="btnLoading"
      :disabled="btnLoading"
      loading-text="请稍后..."
      type="primary"
      native-type="button"
      @click="handlePayClick"
    >
      付货
    </van-button>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { ref, computed, watch } from 'vue'
import {
  departmentList,
  payList,
  inventoryPay
} from '@/api/cylinderManageUserHome'
import { useGetData } from '@/hooks/useGetData'
import { useChecked } from '@/hooks/useChecked'
import { useLoadingMore } from '@/hooks/useLoadingMore'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useSubmit } from '@/hooks/useSubmit'
export default {
  name: 'DirectPayment', // 直接付货
  props: ['id'],
  setup(props) {
    // 获取部门列表
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    const groupList = ref([])
    useGetData(departmentList, (data) => {
      groupList.value = data
    })(companyId.value)
    // 获取列表
    const data = useLoadingMore(payList)
    const { getList, list, finished, loadingFail, pageParams } = data

    // 初始化list
    const init = () => {
      list.value = []
      pageParams.departmentId = props.id
      pageParams.page = 1
      finished.value = false
      loadingFail.value = false
      getList()
    }
    init()

    // 选择钢瓶
    const capacity = computed(() => {
      // 容量
      let res = 0
      list.value.forEach(({ cylinderCapacity }) => {
        res += cylinderCapacity
      })
      return res
    })
    const { checkedAll, checked, checkboxGroup, handleCheckedAllClick } =
      useChecked(list)

    // 付货
    const router = useRouter()
    const userId = computed(() => store.state.userInfo.id)
    const userName = computed(() => store.state.userInfo.nickName)
    const params = computed(() => {
      const res = checked.value.map((item) => ({
        cylinderId: item,
        departmentId: props.id,
        userId: userId.value,
        userName: userName.value
      }))
      return res
    })
    const btnLoading = ref(false)
    const handlePayClick = () => {
      if (!checked.value.length) {
        Toast('请选择钢瓶')
      } else {
        const { onSubmit, loading } = useSubmit(
          inventoryPay,
          params.value,
          () => {
            router.back()
          }
        )
        watch(loading, (val) => {
          btnLoading.value = val
        })
        onSubmit()
      }
    }

    return {
      groupList,
      list,
      capacity,
      checkedAll,
      checked,
      checkboxGroup,
      handleCheckedAllClick,
      ...data,
      init,
      handlePayClick,
      btnLoading
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  margin: 16px;
  color: #666;
  font-size: 14px;
  span {
    margin-right: 5px;
    strong {
      font-weight: 600;
      color: #000;
      padding: 0 5px;
    }
  }
}
.list {
  font-size: 14px;
  padding: 0 16px;
  .list-item {
    display: flex;
    align-items: center;
    padding: 10px;
    &__gsId {
      flex: 1;
    }
    &__residua-gas {
      margin: 0 50px 0 10px;
      width: 80px;
      text-align: right;
    }
  }
  .list-title {
    padding-bottom: 5px;
    margin-bottom: 5px;
  }
  .list-child {
    margin-bottom: 10px;
    &:nth-child(odd) {
      background-color: #fff;
    }
    &:nth-child(even) {
      background-color: #ededed;
    }
  }
}
.btn-conatiner {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
}
</style>
